<template>
  <v-dialog v-if="this.selected_c2c?.c2c" v-model="show" width="740" max-height="200px" persistent lazy>
    <v-card>
      <v-card-title>
        <v-flex grow>
          <h2 class="font-weight-light base--text"> {{ $t("C2C.Title") }} </h2>
        </v-flex>

        <v-spacer></v-spacer>

        <v-btn color="base" fab small icon @click="close">
          <v-icon small class="subPrimary--text">close</v-icon>
        </v-btn>
      </v-card-title>

      <v-divider></v-divider>

      <v-card>
        <iframe style="height:28em" width="100%" v-bind:src="this.selected_c2c.c2c"></iframe>
      </v-card>

      <v-divider></v-divider>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: "GraphicsUrl",
  props: {
    show: {
      type: Boolean,
      required: true
    },
  },
  computed: {
    ...mapState({
      selected_c2c: state => state.parts.selected_c2c
    })
  },
  methods: {
    close() {
      this.$root.$emit("close-modal", "graphicsUrl");
    },
    openGraphicsUrl() {
      this.TOGGLE_MODAL_STATE({ name: 'graphicsUrl', value: true });
    },
  },
};
</script> 